export default function PositioningStatement() {
  return (
    <section
      className="relative bg-[#F7F8FA] border-y border-[#E5E7EB] py-32 px-6 md:px-10 overflow-hidden"
      style={{ fontFamily: "Inter, sans-serif" }}
    >
      {/* Background image */}
      <div className="absolute inset-0 pointer-events-none">
        <img
          src="https://public.readdy.ai/ai/img_res/4cc941214eeb661e245815b6bf13ae5d.jpg"
          alt=""
          className="w-full h-full object-cover object-center opacity-30"
        />
      </div>
      {/* Fade overlay */}
      <div className="absolute inset-0 pointer-events-none bg-gradient-to-b from-[#F7F8FA] via-transparent to-[#F7F8FA]" />
      <div className="absolute inset-0 pointer-events-none bg-gradient-to-r from-[#F7F8FA] via-transparent to-[#F7F8FA]" />

      <div className="relative z-10 max-w-4xl mx-auto text-center">
        <p className="text-xs font-medium text-[#4F46E5] uppercase tracking-widest mb-8">
          Our Position
        </p>

        <h2 className="text-4xl md:text-6xl lg:text-7xl font-semibold text-[#1F2933] tracking-[-0.03em] leading-[1.06] mb-6">
          Not another tool.
        </h2>
        <h2 className="text-4xl md:text-6xl lg:text-7xl font-semibold tracking-[-0.03em] leading-[1.06] mb-10"
          style={{
            background: "linear-gradient(135deg, #4F46E5 0%, #818CF8 100%)",
            WebkitBackgroundClip: "text",
            WebkitTextFillColor: "transparent",
            backgroundClip: "text",
          }}
        >
          An operational intelligence layer.
        </h2>

        <div className="w-12 h-px bg-[#E5E7EB] mx-auto mb-8" />

        <p className="text-base md:text-xl text-[#6B7280] leading-relaxed max-w-2xl mx-auto font-normal">
          Noveka AI installs a system across your business that ensures every input leads to
          execution—with zero gaps, zero delays, zero oversight needed.
        </p>

        {/* Three pillars */}
        <div className="mt-14 grid grid-cols-1 sm:grid-cols-3 gap-5">
          {[
            { icon: "ri-focus-3-line", label: "Zero Gaps", sub: "Every input is captured and processed" },
            { icon: "ri-timer-flash-line", label: "Zero Delays", sub: "Immediate routing and execution" },
            { icon: "ri-eye-off-line", label: "Zero Oversight", sub: "Systems run without intervention" },
          ].map((p) => (
            <div
              key={p.label}
              className="bg-white/80 backdrop-blur-sm border border-[#E5E7EB] rounded-[16px] px-6 py-6 hover:shadow-[0_4px_20px_rgba(0,0,0,0.07)] hover:-translate-y-0.5 transition-all duration-200"
            >
              <div className="w-9 h-9 flex items-center justify-center rounded-[9px] bg-[#EEF2FF] border border-[#C7D2FE] mx-auto mb-4">
                <i className={`${p.icon} text-base text-[#4F46E5]`}></i>
              </div>
              <p className="text-sm font-semibold text-[#1F2933] mb-1">{p.label}</p>
              <p className="text-xs text-[#6B7280]">{p.sub}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
